/* import __COLOCATED_TEMPLATE__ from './media.hbs'; */
/**

## Media Block / Media

The Media section of the [Media Block](../media-block.html)

### Contextual Components

| Description | Contextual Component |
| --- | --- |
| Image | [responsive-image](./responsive-image.html) |
| Block | [media-block/section](./media-block/section.html) |

### Parameters
@param {string} [crop="fit"] 'fit' or 'fill'. Determines if the image can be cropped by it's container or if the full image should be shown.
@param {hash} [overlay] If passed, will display a translucent overlay on top of the media
@param {string} [overlay.color] A color keyword for the overlay color. 'light' or 'dark'
@param {string} [overlay.direction] If passed the overlay will be a gradient instead of a solid color and render in the direction of 'top' 'bottom' 'left' or 'right'.
**/

import Component from '@ember/component';
import { computed } from '@ember/object';
export const MEDIA_BLOCK_IMAGE_CROP = {
  FIT: 'fit',
  FILL: 'fill'
};
export const MEDIA_BLOCK_OVERLAY_GRADIENT_DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right',
  TOP: 'top',
  BOTTOM: 'bottom'
};
export const MEDIA_BLOCK_OVERLAY_COLOR = {
  DARK: 'dark',
  LIGHT: 'light'
};

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['media-block__media'],
  classNameBindings: ['cropClass', 'overlayClasses'],
  attributeBindings: ['data-test-media-block-media'],
  'data-test-media-block-media': true,
  crop: MEDIA_BLOCK_IMAGE_CROP.FIT,
  cropClass: computed('crop', function () {
    if (this.crop === MEDIA_BLOCK_IMAGE_CROP.FILL) {
      return 'media-block__media--crop-fill';
    } else {
      return 'media-block__media--crop-fit';
    }
  }),
  overlayClasses: computed('overlay.{color,direction}', function () {
    if (this.overlay) {
      let overlayClasses = `media-block__media--overlay media-block__media--overlay--${this.overlay.color}`;
      if (this.overlay.direction) {
        overlayClasses = `${overlayClasses} media-block__media--overlay-gradient media-block__media--overlay-gradient--${this.overlay.direction}`;
      }
      return overlayClasses;
    } else {
      return '';
    }
  })
});